import React, { FC } from 'react';
import FormStateContainer from 'components/workflowOptions/sendForApproval/FormStateContainer';
import RequestContainer from 'components/workflowOptions/sendForApproval/RequestContainer';
import { PostStatus, STATUS } from '@kontentino/kontentino-constants/Posts';
import SendForApprovalForm from 'components/workflowOptions/sendForApproval/SendForApprovalForm';
import { Button, Icon } from '@kontentino/ui';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { useTranslation } from 'react-i18next';
type Props = {
  type: ApprovalType;
  postId: number;
  pageId: number;
  onUpdated(status: PostStatus): void;
};

const SendForApprovalPopup: FC<Props> = ({
  type,
  postId,
  pageId,
  onUpdated,
}) => {
  const { t } = useTranslation();

  function onSuccess() {
    onUpdated(
      type === 'client'
        ? STATUS.AT_CLIENT
        : STATUS.WAITING_FOR_INTERNAL_APPROVAL,
    );
  }

  return (
    <RequestContainer type={type} successCallback={onSuccess}>
      {(requestParams) => (
        <FormStateContainer
          preselectedValues={{
            posts: [postId],
            profiles: [pageId],
          }}
          onSubmit={requestParams.submitSendForApproval}
        >
          {(stateParams) => (
            <>
              <SendForApprovalForm
                type={type}
                onSelectedUsersChange={stateParams.handleChangeSelectedUsers}
                initialSelectedUserIds={stateParams.formState.selectedUsers}
                formErrors={stateParams.formErrors}
                pageIds={[pageId]}
                postIds={[postId]}
                subject={stateParams.formState.subject}
                bodyMessage={stateParams.formState.bodyMessage}
                onSubjectChange={stateParams.changeSubject}
                onBodyMessageChange={stateParams.changeBodyMessage}
                onAdditionalEmailsChange={stateParams.changeAdditionalEmails}
                additionalEmails={stateParams.formState.additionalEmails}
              />
              <div className="tw-mt-4 tw-flex tw-justify-end">
                <Button
                  onClick={stateParams.sendForApproval}
                  isLoading={requestParams.isLoading}
                  iconBefore={<Icon icon={faUser} />}
                  data-name={`workflow-options-dropdown_${type}-approval_submit`}
                  data-cy={`workflow-options-dropdown_${type}-approval_submit`}
                >
                  {t('sendForApproval')}
                </Button>
              </div>
            </>
          )}
        </FormStateContainer>
      )}
    </RequestContainer>
  );
};

export default SendForApprovalPopup;
